import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Grid2,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Stack,
  useTheme,
} from "@mui/material";
import { optionInfo, reportForm } from "./Report";
import { useThemeMode } from "Contexts/ThemeContext";

// コンポーネントの Props の型
type NewMailDialogProps = {
  open: boolean;
  handleClose: () => void;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange: (event: SelectChangeEvent<string>) => void;
  handleOutput: () => void;
  outputForm: reportForm;
  targetOptions: optionInfo[];
};

const ReportOutputCsvDialog: React.FC<NewMailDialogProps> = (props) => {
  const {
    open,
    handleClose,
    handleInputChange,
    handleSelectChange,
    handleOutput,
    outputForm,
    targetOptions,
  } = props;

  const theme = useTheme();
  const { mode } = useThemeMode();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: { maxWidth: "350px", minWidth: "350px" },
      }}
    >
      <Box sx={{ backgroundColor: theme.palette.custom.sForm }}>
        <DialogTitle sx={{ pb: 0.5 }}>CSV出力</DialogTitle>
        <DialogContent sx={{ pb: 0.5 }}>
          <Stack direction="column" spacing={1.5} sx={{ p: 1 }}>
            {/* 出力期間 */}
            <Grid2 size={{ xs: 6, sm: 3 }}>
              <TextField
                label="出力期間開始日"
                type="date"
                name="startDate"
                value={outputForm.startDate}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{
                  input: {
                    ...(mode === "dark" && {
                      "&::-webkit-calendar-picker-indicator": {
                        filter: "invert(1)",
                      },
                    }),
                  },
                }}
              />
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 3 }}>
              <TextField
                label="出力期間終了日"
                type="date"
                name="endDate"
                value={outputForm.endDate}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{
                  input: {
                    ...(mode === "dark" && {
                      "&::-webkit-calendar-picker-indicator": {
                        filter: "invert(1)",
                      },
                    }),
                  },
                }}
              />
            </Grid2>
            {/* 出力対象単位 */}
            <Grid2 size={{ xs: 6, sm: 3 }}>
              <FormControl fullWidth variant="outlined">
                <InputLabel shrink>出力対象単位</InputLabel>
                <Select
                  value={outputForm.unit}
                  name="unit"
                  onChange={handleSelectChange}
                  label="出力対象単位"
                  displayEmpty
                >
                  <MenuItem value="" style={{ minHeight: 36 }}></MenuItem>
                  <MenuItem value="0">タグID</MenuItem>
                  <MenuItem value="1">シリアルNo</MenuItem>
                  <MenuItem value="2">エリア</MenuItem>
                </Select>
              </FormControl>
            </Grid2>
            {/* 出力対象 */}
            <Grid2 size={{ xs: 6, sm: 3 }}>
              <FormControl fullWidth disabled={!outputForm.unit}>
                <InputLabel shrink>出力対象</InputLabel>
                <Select
                  value={
                    targetOptions.some(
                      (option) => option.id === outputForm.targetId
                    )
                      ? outputForm.targetId
                      : ""
                  }
                  name="target"
                  onChange={handleSelectChange}
                  label="出力対象"
                  displayEmpty
                >
                  <MenuItem value="" style={{ minHeight: 36 }}></MenuItem>
                  {targetOptions.map((option, index) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>
            <Grid2 size={{ xs: 6, sm: 3 }}></Grid2>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pt: 0.5 }}>
          <Button sx={{ width: "15vh" }} onClick={handleClose}>
            キャンセル
          </Button>
          <Button
            onClick={handleOutput}
            sx={{ width: "15vh" }}
            variant="contained"
            color="primary"
          >
            出力
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ReportOutputCsvDialog;
